module.exports = __webpack_public_path__ + "img/plastic-waste-7617451_1280.9b307d61.jpg";